export default __webpack_public_path__ + "static/media/MARI.d5b9909f.png";